import React from 'react';

import Modal from './Modal';
import NewDocsForm from './NewDocsForm';

class NewDocsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: undefined,
    };
  }

  render() {
    if (this.state.errorMessage) {
      return <h3>{this.state.errorMessage}</h3>;
    }
    const { show, visibleFirmId, closeModalFunc, clientId, inquiryId, parent } = this.props;

    return (
      <Modal open={show} title={'Add Document'} hideButtons={true} onCancel={closeModalFunc}>
        <NewDocsForm
          visibleFirmId={visibleFirmId}
          clientId={clientId}
          inquiryId={inquiryId}
          closeModalFunc={closeModalFunc}
          parent={parent}
        />
      </Modal>
    );
  }
}

export default NewDocsModal;
